import { apiCall } from '../../utils/restclient'
import {
  ADD_CREDIT_CARD,
  ADD_CREDIT_CARD_ERROR,
  ADD_CREDIT_CARD_SUCCESS,
  BOOK_VISIT,
  BOOK_VISIT_ERROR,
  BOOK_VISIT_SUCCESS,
  GET_CREDIT_CARDS,
  GET_CREDIT_CARDS_ERROR,
  GET_CREDIT_CARDS_SUCCESS,
  GET_PAYMENT_KEYS,
  GET_PAYMENT_KEYS_ERROR,
  GET_PAYMENT_KEYS_SUCCESS,
  GET_PROVIDER_INFO,
  GET_PROVIDER_INFO_ERROR,
  GET_PROVIDER_INFO_SUCCESS,
  RESCHEDULE_VISIT,
  RESCHEDULE_VISIT_ERROR,
  RESCHEDULE_VISIT_SUCCESS,
  SEARCH_FOR_PATIENT,
  SEARCH_FOR_PATIENT_ERROR,
  SEARCH_FOR_PATIENT_SUCCESS,
  SEARCH_FOR_PROVIDER_AVAILABILITY_SUCCESS,
  SEARCH_FOR_PROVIDER_AVAILABILITY,
  SEARCH_FOR_PROVIDER_AVAILABILITY_ERROR,
} from './NewVisitConstants'
import { RESCHEDULE_VISIT_PAGE_PATH } from '../../utils/constants'
import { Adyen } from '@quickmd-llc/design-system'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function searchForPatient(searchValue, bookingId, searchId) {
  const endpoint = `api/v1/patients/autocomplete?SearchValue=${encodeURIComponent(searchValue)}`
  const extraData = { searchId, bookingId }
  const action = {
    type: SEARCH_FOR_PATIENT,
    extraData,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: SEARCH_FOR_PATIENT_SUCCESS,
      error: SEARCH_FOR_PATIENT_ERROR,
      extraData,
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function getProviderInfo(providerId, bookingId) {
  const endpoint = `api/v1/providers/${providerId}`
  const extraData = { providerId, bookingId }
  const action = {
    type: GET_PROVIDER_INFO,
    extraData,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: GET_PROVIDER_INFO_SUCCESS,
      error: GET_PROVIDER_INFO_ERROR,
      extraData,
    })
    return action
  } catch (e) {
    console.log(e)
  }
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function getProviderInfoPromise(providerId) {
  const endpoint = `api/v1/providers/${providerId}`

  return new Promise((resolve, reject) => {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      success: (response) => {
        resolve(response)
      },
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      error: (error) => {
        reject(error)
      },
    })
  })
}
// In your actions file
export const fetchProviderAndNavigate =
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  (providerId, visitId, updatedVisit, timeZone, navigate, getRescheduleLocationState) => async (dispatch) => {
    try {
      const endpoint = `api/v1/providers/${providerId}`
      const response = await apiCall(endpoint, 'GET')

      // Optionally dispatch actions if needed
      dispatch({
        type: GET_PROVIDER_INFO_SUCCESS,
        payload: response,
        extraData: { providerId, bookingId: visitId },
      })

      const updatedVisitWithProvider = { ...updatedVisit, Provider: response }

      navigate(RESCHEDULE_VISIT_PAGE_PATH, {
        state: getRescheduleLocationState(updatedVisitWithProvider, timeZone),
      })
    } catch (error) {
      // Dispatch error action if needed
      dispatch({
        type: GET_PROVIDER_INFO_ERROR,
        payload: error,
        extraData: { providerId, bookingId: visitId },
      })
      console.error('Failed to load provider info:', error)
    }
  }

export type SearchForProviderAvailabilityParams = {
  fromDateTime: string
  toDateTime: string
  timeZone: string
  visitTypeId: string
  patientId: string
  bookingId: string
  searchId?: string
  /**
   * VisitId of the visit being rescheduled. When set, the backend restricts the offered slots to
   * times the provider is available at that visit's treatment center (in-person visits only — it
   * is ignored for telehealth). Omitted entirely when absent, so the create-visit flow is unchanged.
   * Nullable because the API models VisitId as `string | null`, and explicitly `undefined`-able
   * because callers pass the key unconditionally (`exactOptionalPropertyTypes` is on).
   */
  rescheduleVisitId?: string | null | undefined
  providerId?: string | null | undefined
}

/**
 * Built by hand rather than with URLSearchParams, which encodes spaces as `+` — the backend's
 * tolerance for that on TimeZone is unverified.
 */
export const buildAvailabilityEndpoint = ({
  fromDateTime,
  toDateTime,
  timeZone,
  visitTypeId,
  patientId,
  rescheduleVisitId,
  providerId,
}: Omit<SearchForProviderAvailabilityParams, 'bookingId' | 'searchId'>) => {
  const params = [
    `FromDateTime=${encodeURIComponent(fromDateTime)}`,
    `ToDateTime=${encodeURIComponent(toDateTime)}`,
    `TimeZone=${encodeURIComponent(timeZone)}`,
    `VisitTypeId=${encodeURIComponent(visitTypeId)}`,
    `PatientId=${encodeURIComponent(patientId)}`,
    ...(rescheduleVisitId ? [`RescheduleVisitId=${encodeURIComponent(rescheduleVisitId)}`] : []),
    ...(providerId ? [`ProviderId=${encodeURIComponent(providerId)}`] : []),
  ]

  return `api/v1/booking/availability?${params.join('&')}`
}

export function searchForProviderAvailability({
  fromDateTime,
  toDateTime,
  timeZone,
  visitTypeId,
  patientId,
  bookingId,
  searchId,
  rescheduleVisitId,
  providerId,
}: SearchForProviderAvailabilityParams) {
  const endpoint = buildAvailabilityEndpoint({
    fromDateTime,
    toDateTime,
    timeZone,
    visitTypeId,
    patientId,
    rescheduleVisitId,
    providerId,
  })

  const extraData = { bookingId, searchId }

  const action = {
    type: SEARCH_FOR_PROVIDER_AVAILABILITY,
    extraData,
  }

  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: SEARCH_FOR_PROVIDER_AVAILABILITY_SUCCESS,
      error: SEARCH_FOR_PROVIDER_AVAILABILITY_ERROR,
      extraData,
    })

    return action
  } catch (error) {
    console.error('Error fetching provider availability:', error)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function getPatientCreditCards(patientId, bookingId, adyenIsEnabled) {
  const extraData = { patientId, bookingId }
  const action = {
    type: GET_CREDIT_CARDS,
    extraData,
  }
  const endpoint = `api/v1/patients/${patientId}/payments/creditcards${Adyen.getAdyenQueryString(adyenIsEnabled)}`

  // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
  apiCall(endpoint, 'GET', null, null, {
    success: GET_CREDIT_CARDS_SUCCESS,
    error: GET_CREDIT_CARDS_ERROR,
    extraData,
  })
  return action
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function addPatientCreditCard(patientId, bookingId, card, adyen) {
  const extraData = {
    patientId,
    bookingId,
    adyen,
  }
  const action = {
    type: ADD_CREDIT_CARD,
    extraData,
  }
  const endpoint = `api/v1/patients/${patientId}/payments/creditcards${Adyen.getAdyenQueryString(!!adyen)}`
  // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
  apiCall(endpoint, 'POST', null, JSON.stringify(card), {
    success: ADD_CREDIT_CARD_SUCCESS,
    error: ADD_CREDIT_CARD_ERROR,
    extraData,
  })
  return action
}

export function getPaymentKeys() {
  const action = {
    type: GET_PAYMENT_KEYS,
  }
  const endpoint = `api/v1/payments/keys`

  // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
  apiCall(endpoint, 'GET', null, null, {
    success: GET_PAYMENT_KEYS_SUCCESS,
    error: GET_PAYMENT_KEYS_ERROR,
  })
  return action
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function bookVisit(visit, bookingId, patientId, adyenIsEnabled) {
  const extraData = { bookingId, patientId }
  const action = {
    type: BOOK_VISIT,
    extraData,
  }

  const endpoint = `api/v1/visits${Adyen.getAdyenQueryString(adyenIsEnabled)}`

  // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
  apiCall(endpoint, 'POST', null, JSON.stringify(visit), {
    success: BOOK_VISIT_SUCCESS,
    error: BOOK_VISIT_ERROR,
    extraData,
  })
  return action
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const rescheduleVisit = ({ visitId, requestData }) => {
  const extraData = { bookingId: visitId }

  const action = {
    type: RESCHEDULE_VISIT,
    extraData,
  }

  const endpoint = `api/v1/visits/${visitId}/reschedule`

  // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
  apiCall(endpoint, 'PUT', null, JSON.stringify(requestData), {
    success: RESCHEDULE_VISIT_SUCCESS,
    error: RESCHEDULE_VISIT_ERROR,
    extraData,
  })
  return action
}
